import { Link } from 'react-router-dom';

const SMARTSTORE_MAIN = 'https://smartstore.naver.com/proactivecare';

interface Product {
  id: number;
  name: string;
  category: string;
  desc: string;
  image: string;
  purchaseUrl?: string;
  detail: {
    subtitle: string;
    highlights: string[];
    description: string;
    usage: string;
    caution: string;
  };
}

interface Props {
  product: Product;
}

const ProductDetailHero = ({ product }: Props) => (
  <section className="pt-28 pb-20 bg-[#f8f9fb]">
    <div className="max-w-6xl mx-auto px-6 md:px-10">
      {/* Breadcrumb */}
      <nav className="flex items-center gap-2 text-xs text-gray-400 mb-10">
        <Link to="/" className="hover:text-[#1a2b4a] transition-colors duration-200 cursor-pointer">홈</Link>
        <i className="ri-arrow-right-s-line text-sm" />
        <Link to="/#products" className="hover:text-[#1a2b4a] transition-colors duration-200 cursor-pointer">제품소개</Link>
        <i className="ri-arrow-right-s-line text-sm" />
        <span className="text-[#1a2b4a] font-medium">{product.name}</span>
      </nav>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Image */}
        <div className="bg-white rounded-2xl p-10 flex items-center justify-center border border-gray-100 min-h-[400px]">
          <img
            src={product.image}
            alt={product.name}
            className="w-full max-w-sm h-80 object-contain"
          />
        </div>

        {/* Info */}
        <div>
          <span className="inline-block text-xs font-semibold text-[#1a2b4a] tracking-[0.2em] uppercase bg-[#1a2b4a]/8 px-3 py-1.5 rounded-full mb-4">
            {product.category}
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-3 leading-tight">
            {product.name}
          </h1>
          <p className="text-base text-gray-400 mb-8 leading-relaxed">
            {product.detail.subtitle}
          </p>

          {/* Highlights */}
          <ul className="flex flex-col gap-3 mb-10">
            {product.detail.highlights.map((item) => (
              <li key={item} className="flex items-center gap-3 text-sm text-gray-600">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#1a2b4a] flex-shrink-0">
                  <i className="ri-check-line text-white text-xs" />
                </span>
                {item}
              </li>
            ))}
          </ul>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={product.purchaseUrl && product.purchaseUrl !== '#purchase' ? product.purchaseUrl : SMARTSTORE_MAIN}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center justify-center gap-2 bg-[#03C75A] text-white text-sm font-semibold px-8 py-3.5 rounded-md hover:bg-[#02b050] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-store-2-line text-base" />
              네이버 스마트스토어 구매
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ProductDetailHero;
